'use client';

import React from 'react';

import { useParams } from 'next/navigation';

import classNames from 'classnames';
import { useRouter } from 'nextjs-toploader/app';

import AnalyticsWrapper from '@/common/components/analytics-wrapper';
import Button from '@/common/components/button/button.component';

export interface HeaderProps {
  setOpen: (value: boolean) => void;
  filtered?: boolean;
}

export default function Header({ setOpen, filtered }: HeaderProps) {
  const router = useRouter();
  const params = useParams();
  const slug = params.slug as string | undefined;
  return (
    <div className="mb-[4px] mt-2 flex w-full flex-wrap items-center justify-between gap-3 lg:hidden">
      <AnalyticsWrapper analytics={['store-click-filter-v1']}>
        <Button
          className={classNames(
            'h-9 flex-1 !text-xs font-medium',
            { '!bg-blue-25 !text-blue-default': filtered },
            {
              '!bg-silver-200 !text-silver-500': !filtered,
            }
          )}
          onClick={() => {
            setOpen(true);
          }}
          id="store-click-filter-v1"
        >
          فیلتر و مرتب‌سازی
        </Button>
      </AnalyticsWrapper>
      <AnalyticsWrapper analytics={['store-click-search-v1']}>
        <Button
          type="tonal"
          className="h-9 flex-1 !bg-silver-200 !text-xs font-medium !text-silver-500"
          onClick={() => {
            router.push(`${slug || ''}/search`);
          }}
          id="store-click-search-v1"
        >
          جست‌و‌جو در محصولات
        </Button>
      </AnalyticsWrapper>
    </div>
  );
}
